/* global window */

export default function applicationNotificationsDirective() {
  console.log('app.components.global.applicationNotifications created');
  return {
    template: require('./application-notifications.directive.html'),
    controller: 'ApplicationNotificationsDirectiveController',
    controllerAs: 'applicationNotificationsVM',
    bindToController: true,
    replace: true,
    link: linkFunction
  };
}

function linkFunction(scope) {
  scope.applicationNotificationsVM.applicationNotificationsActive = false;
  scope.applicationNotificationsVM.toggleMenuVisibility = (type) => {
    scope.applicationNotificationsVM[`${type}Active`] = !scope.applicationNotificationsVM[`${type}Active`];
  };
  const everywhere = angular.element(window.document);

  everywhere.bind('click', (event) => {
    const applicationNotificationsClicked = angular.element(
      event.target
    ).hasClass('application-notifications-button');
    if (applicationNotificationsClicked) {
      scope.applicationNotificationsVM.unacknowledgedActionItemsCount = 0;
    } else {
      scope.applicationNotificationsVM.applicationNotificationsActive = false;
    }

    scope.$apply();
  });
}
